import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiX, FiHome, FiTrendingUp, FiPhone, FiWifi } from 'react-icons/fi';
import styles from './Header.module.css';

const MobileMenu = ({ isOpen, onClose }) => {
    const location = useLocation();

    const menuVariants = {
        open: {
            x: 0,
            transition: {
                type: 'spring',
                stiffness: 300,
                damping: 30
            }
        },
        closed: {
            x: '100%',
            transition: {
                type: 'spring',
                stiffness: 300,
                damping: 30
            }
        }
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <div className={styles.mobileMenu}>
            <motion.div
                className={styles.mobileMenuContent}
                initial="closed"
                animate="open"
                exit="closed"
                variants={menuVariants}
            >
                <button className={styles.mobileCloseButton} onClick={onClose}>
                    <FiX size={24} />
                </button>

                <ul className={styles.mobileNavList}>
                    <li className={styles.mobileNavItem}>
                        <Link 
                            to="/" 
                            className={`${styles.mobileNavLink} ${isActive('/') ? styles.active : ''}`}
                            onClick={onClose}
                        >
                            <FiHome size={20} />
                            Ana Sayfa
                        </Link>
                    </li>
                    <li className={styles.mobileNavItem}>
                        <Link 
                            to="/kampanyalar" 
                            className={`${styles.mobileNavLink} ${isActive('/kampanyalar') ? styles.active : ''}`}
                            onClick={onClose}
                        >
                            <FiTrendingUp size={20} />
                            Kampanyalar
                        </Link>
                    </li>
                    <li className={styles.mobileNavItem}>
                        <Link 
                            to="/hiz-testi" 
                            className={`${styles.mobileNavLink} ${isActive('/hiz-testi') ? styles.active : ''}`}
                            onClick={onClose}
                        >
                            <FiWifi size={20} />
                            Hız Testi
                        </Link>
                    </li>
                    <li className={styles.mobileNavItem}>
                        <Link 
                            to="/iletisim" 
                            className={`${styles.mobileNavLink} ${isActive('/iletisim') ? styles.active : ''}`}
                            onClick={onClose}
                        >
                            <FiPhone size={20} />
                            İletişim
                        </Link>
                    </li>
                </ul>

                <a 
                    href="tel:+908508079898" 
                    className={styles.mobileCtaButton}
                    onClick={onClose}
                >
                    <span>📞</span>
                    Hemen Ara
                </a>
            </motion.div>
        </div>
    );
};

export default MobileMenu;